
export const type= 'SEND-CONTACTO'
const SendContacto = ()=>({
    type
})
export default SendContacto